import { BlockVariant, CustomBlockProps, DropdownListBlockProps, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { FileService, NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { OpinionBlockComponent } from '@/components/shared/opinion-block/opinion-block.component';
import { JointDoc, PpmOpinion } from '@/types';
import { inject, Injectable } from '@angular/core';

interface ReportMetadataBlocksServiceProps {
  pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>;
  ppmOpinions?: PpmOpinion[];
}

@Injectable({
  providedIn: 'root',
})
export class ReportMetadataBlocksService {
  fileService = inject(FileService);

  getPvsBlocks(pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>): DynamicBlock[] {
    const bulltedLists: DynamicBlock<DropdownListBlockProps>[] = pvItems
      ? (Object.keys(pvItems)
          .map(key => {
            if (pvItems[key].items.length === 0) return null;
            return {
              variant: BlockVariant.DROPDOWN_LIST,
              props: {
                label: key,
                items: pvItems?.[key].items,
                renderAs: (item: JointDoc) => {
                  return {
                    type: 'LINK',
                    value: item.ref,
                    class: 'underline text-blue-600',
                  };
                },
                onClick: (item: JointDoc) => {
                  this.fileService.download({ alfresco_id: item.alfrescoId, filename: item.ref, extension: 'pdf' }, pvItems[key].nameSpace);
                },
              },
            };
          })
          .filter(Boolean) as DynamicBlock[])
      : [];
    return bulltedLists;
  }

  getPPMOpinionsBlocks(ppmOpinions?: PpmOpinion[]): DynamicBlock<CustomBlockProps>[] {
    if (!ppmOpinions || ppmOpinions.length === 0) return [];

    return ppmOpinions.map(opinion => ({
      variant: BlockVariant.CUSTOM,
      props: {
        component: OpinionBlockComponent,
        inputs: {
          avis: opinion.avis,
          user: opinion.user,
          createdAt: opinion.createdAt,
          alfrescoId: opinion.alfrescoId,
          namespace: NAMESPACE_ENUM.OPINION_REPORT,
        },
      } satisfies CustomBlockProps,
    }));
  }

  getMetadataBlocks({ pvItems, ppmOpinions }: ReportMetadataBlocksServiceProps): DynamicBlocks[] {
    const pvBlocks = this.getPvsBlocks(pvItems);
    const opinionBlocks = this.getPPMOpinionsBlocks(ppmOpinions);

    const result: DynamicBlocks = {};

    if (pvBlocks && pvBlocks.length > 0) {
      result['1'] = pvBlocks;
      result['2'] = [
        {
          variant: BlockVariant.SEPERATOR,
        } satisfies DynamicBlock,
      ];
    }

    if (opinionBlocks.length > 0) {
      result['3'] = opinionBlocks;
    }

    return Object.keys(result).length > 0 ? [result] : [];
  }
}
